function toggleSelectedDiv(e, element) {
  if (e.keyCode !== undefined && e.keyCode !== 13) 
    return;

  const allSelectedDivs = document.querySelectorAll('.selected-div');
  allSelectedDivs.forEach(div => {
    div.classList.remove('selected-div');
    const addBtn = div.querySelector('.add-gift-btn');
    if (addBtn) {
      addBtn.innerHTML = 'ADD';
    }
  });

  const parentDiv = element.closest('.dtc-prod-box');
  if (parentDiv) {
    const selectInput = parentDiv.querySelector('select');

    const variantIdSelector = parentDiv.querySelector('[name="size"]');
    let shouldSelect = true;
    if (selectInput) {
      shouldSelect = selectInput.value ? true : false;
    }
    if (shouldSelect) {
      parentDiv.classList.add('selected-div');
      localStorage.setItem('selectedProduct', parentDiv.dataset.handle);
      localStorage.setItem('selectedVariantId', variantIdSelector.value);
      const addBtn = parentDiv.querySelector('.add-gift-btn');
      if (addBtn) {
        addBtn.innerHTML = 'ADDED!';
      }
    } else {
      console.log("Please select a variant before adding this product.");
    }
  }
}
window.addEventListener('click', function (evt) {
  if (evt.target.classList.contains('dtc-checkout-button')) {
    evt.preventDefault();
    const $selectedProduct = document.querySelector('.selected-div [name="size"]');
    const { dtcCoupon } = document.querySelector('.dtc-section').dataset;
    if ($selectedProduct) {
      let id = $selectedProduct.value;
      let properties = {};
      properties['__freeGift'] = true;
      let params = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id,
          quantity: 1,
          properties,

        })
      }
      return fetch('/cart/add.js', params)
        .then(res => res.json())
        .then(data => {
          if (dtcCoupon) {
            return fetch(`/discount/${dtcCoupon}`)
          }
          window.location.href = evt.target.getAttribute('href');
        })
        .then(res => window.location.href = evt.target.getAttribute('href'))

    }
    window.location.href = evt.target.getAttribute('href');
  }
  if (evt.target.classList.contains('add-gift-btn')) {
    evt.preventDefault();
    toggleSelectedDiv(null, evt.target);
  }
});
function updateCartTotal() {
  return theme.cart.getCart().then(cart => {
    document.querySelector('.drawer__footer .ajaxcart__price').innerText = theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat)
  })
}
function checkGiftItems() {
  theme.cart.getCart().then(cart => {
    const { items } = cart;
    items.forEach((item, index) => {
      if (item.properties && item.properties['__freeGift']) {
        let $item = document.querySelector(`.ajaxcart__product[data-pid="${item.id}"]`);
        $item.remove();
        $.post('/cart/change.js', {
          line: index + 1,
          quantity: 0
        }, function (response) {
          return updateCartTotal();
        });
      }
    })
  })
}

function initSlider() {
  const swiper = new Swiper('.dtc-swiper', {
    slidesPerView: 1,
    navigation: {
      nextEl: null,
      prevEl: null,
    },
    allowTouchMove: true,
    breakpoints: {

      768: {
        slidesPerView: 1,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        allowTouchMove: false,

      },
    },
  });
}
const fetchSection = () => {
  fetch(window.Shopify.routes.root + "?section_id=dtc-cart-incentives")
    .then(res => res.text())
    .then(data => {
      const html = document.createElement('div');
      html.innerHTML = data;

      const $altWrapperContainer = document.querySelector('.dtc-main-gift-slider') || null;
      if ($altWrapperContainer) {
        $altWrapperContainer.innerHTML = '';
        if (html.querySelector('#shopify-section-dtc-cart-incentives .dtc-section .dtc-gift-wrapper' !== null)){
          $altWrapperContainer.append(html.querySelector('#shopify-section-dtc-cart-incentives .dtc-section .dtc-gift-wrapper'));
        }
      }

      $mainProgressBarSelector.innerHTML = '';
      $mainProgressBarSelector.append(html.querySelector('#shopify-section-dtc-cart-incentives .dtc-section'));
      initSlider();
      const retrievedString = localStorage.getItem('selectedProduct');
      if (retrievedString !== null) {
        let selectedElement = document.querySelector(`.dtc-main-gift-slider [data-handle=${retrievedString}]`);

        if (!selectedElement.classList.contains('locked')) {
          selectedElement.classList.add('selected-div');
          selectedElement.querySelector('.add-gift-btn').innerHTML = 'ADDED!';
          let selectSize = selectedElement.querySelector('select');
          if (selectSize) {
            selectSize.value = localStorage.getItem('selectedVariantId');
            selectSize.dispatchEvent(new Event('change', { bubbles: true }));
          }

        }
      }
    })
}
const $mainProgressBarSelector = document.querySelector('.dtc-progress-bar-wrapper');
document.addEventListener('cart:updated', evt => {
  checkGiftItems();
  setTimeout(() => {
    const { item_count } = evt.detail.cart;
    if (item_count === 0) {
      $mainProgressBarSelector.innerHTML = '';
      return;
    }
    fetchSection();
  }, 500);

});
